import * as React from 'react';

import {ColorPicker} from 'shells/color-picker/color-picker';
import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {CheckmarkIcon} from 'shells/icon/svg/checkmark-icon';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';

import styles from './picker.module.css';

type Props = {
    currentColor: string;
    setCurrentColor: (arg1: string) => void;
};

const DEFAULT_COLORS: string[] = [
    colors.red,
    colors.orange,
    colors.greenDk,
    colors.navy,
    colors.dotcomPurple,
];

export function WidgetColorPicker(props: Props) {
    const {currentColor, setCurrentColor} = props;
    const [customColor, setCustomColor] = React.useState<any>(null);

    React.useEffect(() => {
        if (!DEFAULT_COLORS.includes(currentColor)) {
            setCustomColor(currentColor);
        }
    }, [currentColor]);

    return (
        <StackLegacy isHorizontal={true} spacing={8}>
            {DEFAULT_COLORS.map((color) => (
                <button
                    key={color}
                    style={{
                        backgroundColor: color,
                    }}
                    onClick={() => setCurrentColor(color)}
                    className={styles['color-picker-button']}
                >
                    {currentColor === color && (
                        <CheckmarkIcon fill={colors.white} size={15} alignCenter={true} />
                    )}
                </button>
            ))}
            {customColor && (
                <button
                    style={{
                        backgroundColor: customColor,
                        border:
                            currentColor.toLowerCase() === colors.white.toLowerCase()
                                ? `2px dashed ${colors.black}`
                                : `2px solid ${colors.black}`,
                    }}
                    onClick={() => setCurrentColor(customColor)}
                    className={styles['color-picker-button']}
                >
                    {currentColor === customColor && (
                        <CheckmarkIcon
                            fill={
                                currentColor.toLowerCase() === colors.white.toLowerCase()
                                    ? colors.black
                                    : colors.white
                            }
                            size={15}
                            alignCenter={true}
                        />
                    )}
                </button>
            )}
            <div className={styles['color-picker-button']}>
                <ColorPicker
                    openButton='plus'
                    currentColor={currentColor}
                    onSetCurrentColor={(color) => {
                        setCustomColor(color);
                        setCurrentColor(color);
                    }}
                />
            </div>
        </StackLegacy>
    );
}
